import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "dialog"]

  connect() {
    this.handleKeydown = (event) => this.keydown(event)
    window.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    window.removeEventListener("keydown", this.handleKeydown)
    this.unlockPage()
  }

  open(event) {
    event.preventDefault()
    this.trigger = event.currentTarget
    // Loopt de rondleiding, dan wijkt die: anders staan er twee lagen over
    // elkaar heen.
    window.dispatchEvent(new CustomEvent("rondleiding:pause"))
    this.overlayTarget.hidden = false
    document.body.style.overflow = "hidden"
    this.dialogTarget.focus()
  }

  close() {
    if (this.overlayTarget.hidden) return

    this.overlayTarget.hidden = true
    this.unlockPage()
    this.trigger?.focus()
  }

  closeFromBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  startCurrent() {
    this.start("current")
  }

  startFull() {
    this.start("full")
  }

  keydown(event) {
    if (this.overlayTarget.hidden) return

    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    } else if (event.key === "Tab") {
      this.keepFocusInside(event)
    }
  }

  start(mode) {
    this.close()
    window.dispatchEvent(new CustomEvent("rondleiding:start", { detail: { mode } }))
  }

  keepFocusInside(event) {
    const focusable = [...this.dialogTarget.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )].filter((element) => element.offsetParent !== null)
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  unlockPage() {
    document.body.style.removeProperty("overflow")
  }
}
